
export default function ExampleBranchItem({item, index, theme}) {
    const deployDays =(branch)=>{
        return branch.week.map((day, inx)=>{
        return <p key={`exampleBranchesItem_inx_${index}_day_${inx+1}`} className="exampleBranch_day">{day.isOpen ? `${day.day}: ${day.startAt} - ${day.endAt}` : `${day.day}: סגור`}</p>
        })
    }
    return (
        <div className={item.isOpen ? "exampleBranch_open" : "exampleBranch"} style={{border:`0.5px solid ${theme.accent_color}`, backgroundColor:theme.primary_color, color:theme.accent_color}} dir='rtl'>
            <p className="exampleBranch_header" style={{borderBottom:`0.5px solid ${theme.accent_color}`}}>{item.city}</p>
            <div className="exampleBranch_1stP">
                <div className="exampleBranch_location_img"></div>
                <p className="exampleBranch_address">{item.address}</p>
            </div>
            <div className="exampleBranch_2ndP">
            <div style={{display:"flex", flexDirection:"row"}}>
                <div className="exampleBranch_clock_img"></div>
                <p className="exampleBranch_availability">{item.isOpen ? "שעות פעילות:" : "הסניף סגור"}</p>
            </div>
            {item.isOpen && <div style={{margin:"10px 0 0"}}>
                {deployDays(item)}
            </div>}
            </div>
        </div>
    )
}